import { render, staticRenderFns } from "./TransactionRecordSummary.vue?vue&type=template&id=6f4e285f&"
import script from "./TransactionRecordSummary.vue?vue&type=script&lang=js&"
export * from "./TransactionRecordSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports